import React from 'react';
import Modal from './Modal';
import Button from './Button';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function ConfirmationModal({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText,
    cancelText,
    variant = 'danger',
    comment,
    onCommentChange,
    showInput = false,
    inputPlaceholder = "Write a reason...",
}) {
    const { t } = useTranslation();

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
            <div className="flex flex-col items-center text-center p-2">
                <div className={`p-3 rounded-full mb-4 ${variant === 'danger' ? 'bg-red-100 text-red-600' : 'bg-blue-100 text-blue-600'}`}>
                    <AlertTriangle className="w-8 h-8" />
                </div>

                <p className="text-gray-600 mb-6">{message}</p>

                {showInput && (
                    <div className="w-full mb-4 text-left">
                        <textarea
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 text-sm"
                            rows="3"
                            placeholder={inputPlaceholder}
                            value={comment}
                            onChange={(e) => onCommentChange(e.target.value)}
                        />
                    </div>
                )}

                <div className="flex space-x-3 w-full justify-center">
                    <Button variant="ghost" onClick={onClose}>
                        {cancelText || t('btn_cancel')}
                    </Button>
                    <Button variant={variant} onClick={() => { onConfirm(); onClose(); }} disabled={showInput && !comment}>
                        {confirmText || t('btn_save')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
